(() => {
  if (window.opdCartNotesSyncBound) return;
  window.opdCartNotesSyncBound = true;

  const syncNotes = (event) => {
    const input = event.target;
    if (!input || !input.matches('textarea.cart-notes[name="note"]')) return;
    document.querySelectorAll('textarea.cart-notes[name="note"]').forEach((other) => {
      if (other !== input) other.value = input.value;
    });
  };

  document.addEventListener('input', syncNotes);
  document.addEventListener('change', syncNotes);
})();
